// Central list of your Medium articles.
// `tags` controls which book page(s) an article shows up on.
// Use a book's slug (e.g. 'bwgo', 'inbetween') for book-specific pieces,
// and include BOTH slugs (or 'general') for articles that apply to every book.

const articles = [

  {
    slug: 'bwgo-reflections', // change to your real published article's slug
    title: 'Before We Get Older — The Book I Wrote at 20 That I Still Need Today',
    excerpt: "School Taught Me Formulas. Life Taught Me Everything Else.",
    url: 'https://medium.com/@iamloubna/before-we-get-older-the-book-i-wrote-at-20-that-i-still-need-today-30c74b1d2ee2',
    readTime: '4 min read',
    tags: ['bwgo'],
  },

  {
    slug: 'how-to-write-and-finish-a-book',
    title: 'How to Write a Book and Actually Finish it?',
    excerpt: 'Most people who want to write a book never start. Most who start never finish. Here’s what actually worked for me — twice',
    url: 'https://medium.com/@Loubna-DS/how-to-write-a-book-and-actually-finish-it-622eeef88dde?sharedUserId=Loubna-DS',
    readTime: '6 min read',
    tags: ['bwgo', 
     'inbetween'
    ], 
  },

   {
     slug: 'inbetween-reflections',
     title: 'I published my second book: The In-Between- A journey to balance and healing',
     excerpt: 'Reflections on the journey of writing The In-Between and When to read this book.',
     url: 'https://medium.com/@Loubna-DS/i-published-my-second-book-the-in-between-a-journey-to-balance-and-healing-527bbe3f7f85?sharedUserId=Loubna-DS',
    readTime: '5 min read',
     tags: ['inbetween'],
 },
];

export default articles;